import * as React from 'react';

import { Box } from '@rbilabs/component-library';
import { defineMessages, useIntl } from 'react-intl';

import ActionButton, { ActionButtonVariants, ActionLink } from 'components/action-button';
import { routes } from 'utils/routing';

import { Container, LoadingText, StyledModalHeader } from './delivery-unavailable.styled';
import { IDeliveryUnavailableProps } from './types';

const messages = defineMessages({
  deliveryNotAvailable: {
    id: 'deliveryNotAvailable',
    defaultMessage: 'Delivery Unavailable',
    description: 'Text telling the user the delivery is unavailable for entered address',
  },

  cannotDeliveryTo: {
    id: 'cannotDeliveryTo',
    defaultMessage: 'We cannot currently deliver to',
    description: 'Text telling the user we cannot currently deliver to entered address',
  },

  orderPickup: {
    id: 'orderPickup',
    defaultMessage: 'Order Pickup',
    description: 'Button to take them to our order pickup page',
  },

  useDifferentAddress: {
    id: 'useDifferentAddress',
    defaultMessage: 'Use Different Address',
    description: 'Button offering to change the order address',
  },
});

/**
 *
 * DeliveryUnavailable informs the guest that the address they entered
 * is unable to receive delivery at this time
 *
 */

const DeliveryUnavailable: React.FC<IDeliveryUnavailableProps> = ({ address, close }) => {
  const { formatMessage } = useIntl();
  return (
    <Container data-testid="delivery-unavailable-for-address">
      <StyledModalHeader>{formatMessage(messages.deliveryNotAvailable)}</StyledModalHeader>
      <LoadingText>
        {formatMessage(messages.cannotDeliveryTo)}
        <br />
        {address}
      </LoadingText>
      <Box width="100%" minWidth="auto" margin="8px 0" center>
        <ActionLink fullWidth to={routes.storeLocator}>
          {formatMessage(messages.orderPickup)}
        </ActionLink>
      </Box>
      <Box width="100%" minWidth="auto" margin="8px 0" center>
        <ActionButton
          fullWidth
          data-testid="use-different-address"
          onClick={close}
          variant={ActionButtonVariants.OUTLINE}
        >
          {formatMessage(messages.useDifferentAddress)}
        </ActionButton>
      </Box>
    </Container>
  );
};

export default DeliveryUnavailable;
